package de.oevbs.kunde.kundenportal2.model.services.intinscard

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class IntInsCardClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd die Kfz-Vertragsdaten des eingeloggten Users/Partners aus dem CRM.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<IntInsCardInit> =
        get("/intinscard/init")


    /**
     * Stößt die Erstellung einer Internationalen Versicherungskarte über den Komposit-IVK-Servíce (Azure) an für den
     * in [selectedContract] ausgewählten Vertrag. Die Adress
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun createCard(selectedContract: CarContract): ClientResponse<Unit> =
        post("/intinscard/create", selectedContract)

}